import {PrivateStackParamList} from "@app/navigationApp/types";
import {NativeStackScreenProps} from "@react-navigation/native-stack";
import ScreenWrapper from "@hoc/ScreenWrapper";
import {useKYCStatusHandler} from "@screens/KYC/KYCResponse/useKYCStatusHandler";
import {ThemedText, ThemedView} from "@app/theme";
import LottieView from "lottie-react-native";
import { useEffect } from "react";

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'KYC_DIGIO_RESPONSE'>;

const KYCResponse = ({navigation, route}: ScreenProps) => {
    useKYCStatusHandler(navigation);
    useEffect(() => {
        sessionStorage.removeItem("digioFlowStarted");
    }, [])
    return (
        <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute: true}}>
            <ThemedView alignItems={"center"} justifyContent={"center"}  backgroundColor="bg-surface-primary" flex={1}>
                <LottieView source={require("../../../assets/lottie/sand_timer.json")} autoPlay={true} loop={true} />
                <ThemedText variant={"h4s"}>
                    Loading, please wait...
                </ThemedText>
            </ThemedView>
        </ScreenWrapper>
    )
}

export default KYCResponse; 